import { AppState } from '../../app/state/AppState';
import { normalizedContentKey } from '../../home/reducers/NormalizedContentReducer';
import { IContentInfo } from '../../ts/models/IContentInfo';
import { ExploreContentApi_ContentType } from '../../ts/ServerApi/types/IContent';

export function selectItemFromHomeState(state: AppState, contentId: string, contentType: ExploreContentApi_ContentType): IContentInfo {
  return state.home.contentById[normalizedContentKey(contentId, contentType)];
}
